// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__garet_653ed5', '__garet_Fallback_653ed5'"},"className":"__className_653ed5"};